import { render, staticRenderFns } from "./AssistenzaCreateButton.vue?vue&type=template&id=1ce980d0"
import script from "./AssistenzaCreateButton.vue?vue&type=script&lang=js"
export * from "./AssistenzaCreateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports